export class GeocoderReq {
  id: number;
  latitude: number;
  longitude: number;
  languageCode: string;
}
